import {
  ProductFamilyEnum,
  ProductTypeEnum,
  Deal,
  CommercialDeal,
  BridgingDeal,
  DevelopmentFinanceDeal,
} from "@src/apis/ModularClient";

export const isCommercialDeal = (deal: Deal): deal is CommercialDeal => {
  return deal.productFamily === ProductFamilyEnum.Commercial;
};

export const isBridgingDeal = (deal: Deal): deal is BridgingDeal => {
  return deal.productFamily === ProductFamilyEnum.Bridging;
};

export const isDevelopmentFinanceDeal = (deal: Deal): deal is DevelopmentFinanceDeal => {
  return deal.productFamily === ProductFamilyEnum.Development;
};

export const goToCaseDashboard = (dealId: number, productFamily: ProductFamilyEnum, $location: any): void => {
  switch (productFamily) {
    case ProductFamilyEnum.Bridging:
      $location.path(`/bridgingcasedashboard/${dealId}`);
      break;
    case ProductFamilyEnum.Commercial:
      $location.path(`/commercialcasedashboard/${dealId}`);
      break;
    case ProductFamilyEnum.Development:
      $location.path(`/devfinancecasedashboard/${dealId}`);
      break;
  }
};

export const dataSetupOnMaxLoanRequiredChange = (dealDto: any): any => {
  if (!dealDto.maxLoanRequired) {
    dealDto.netLoanRequired = 0;
  }
  return dealDto;
};

export const showBasedOnMainResidence = (dealDto: any): boolean => {
  return (
    dealDto.isFamilyInResidence != 1 ||
    (dealDto.isFamilyInResidence == 1 &&
      (dealDto.productType == ProductTypeEnum.BridgingPurchaseOrRefinance ||
        dealDto.productType == ProductTypeEnum.BridgingRefurb))
  );
};

let showModal: boolean = false;
let dealName: string = "";
let previouslySelectedClient: any = null;

export const getShowSearchNameAndUserSelectionModal = (): boolean => {
  return showModal;
};

export const setShowSearchNameAndUserSelectionModal = (show: boolean): void => {
  showModal = show;
};

export const getDealName = (): string => {
  return dealName;
};

export const setDealName = (name: string): void => {
  dealName = name;
};

export const getClient = (): any => {
  return previouslySelectedClient;
};

export const setClient = (client: any): void => {
  previouslySelectedClient = client;
};

export const getRequiredRolesOptions = (isCaseDashboard: boolean = false, isReadOnlyDeal: boolean = false): string => {
  if (isCaseDashboard) {
    return `[{name: 'Lender', disable: true, hide: false},{name: 'Broker', disable: ${isReadOnlyDeal}, hide: false}]`;
  } else {
    return `[{name: 'Lender', disable: true, hide: false}]`;
  }
};

export const isValidPostcodeString = (postcodeSearchString: string) => {
  if (/^[A-Za-z]{1,2}[0-9]{1}/.test(postcodeSearchString) && postcodeSearchString.replace(" ", "").length <= 7) {
    return true;
  }
  return false;
};

const DealHelper = {
  isCommercialDeal,
  isBridgingDeal,
  isDevelopmentFinanceDeal,
  goToCaseDashboard,
  dataSetupOnMaxLoanRequiredChange,
  showBasedOnMainResidence,
  getShowSearchNameAndUserSelectionModal,
  setShowSearchNameAndUserSelectionModal,
  getDealName,
  setDealName,
  getClient,
  setClient,
  getRequiredRolesOptions,
  isValidPostcodeString,
};

export default DealHelper;
